<template>
   <div :class="`${colSize} col-xs-12`" ref="dashboardCard">
		<div class="panel panel-default card-view pa-0" style="height: 175px; display: flex; flex-direction: column; justify-content: center; margin-bottom: 0px;">
			<div class="panel-wrapper collapse in">
				<div :class=" hasAction ? 'panFel-body with-action pa-0' : 'panel-body pa-0'" @click="sendAction(action)">
					<div class="sm-data-box">
						<div class="container-fluid">
							<div class="row">
								<div class="col-xs-6 text-center pl-0 pr-0 data-wrap-left">
									<span class="txt-dark block counter"><span class="counter-anim">{{count}}</span></span>
									<span class="block">{{$t(title)}}</span>
								</div>
								<div class="col-xs-6 text-center  pl-0 pr-0 data-wrap-right">
									<i :class="`${iconClass} data-right-rep-icon`"></i>
								</div>
							</div>
							<div v-if="percent" class="progress-anim">
								<div class="progress">
									<div class="progress-bar progress-bar-orange
									wow animated progress-animated" role="progressbar" :aria-valuenow="percent" aria-valuemin="0" aria-valuemax="100" :style="`width: ${percent}%;`" v-tooltip="activeOptions">
									</div> 
									<div class="progress-bar progress-bar-grey
									wow animated progress-animated" role="progressbar" :aria-valuenow="100 - percent" aria-valuemin="0" aria-valuemax="100" :style="`width: ${100 - percent}%;`" v-tooltip="inactiveOptions">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  name: "DashboardCard",
  components: {
  },
  props: {
		count: {
			type: Number,
			default: 0
		},
		percent: {
			type: Number,
			required: false
		},
		title: {
			type: String,
			required: true
		},
		iconClass: {
			type: String,
			required: false
		},
		colSize: {
			type: String,
			default: 'col-sm-6'
		},
		hasAction: {
			type: Boolean,
			default: false,
		},
		action: {
			type: String,
			required: false,
		},
		activeLabel: {
			type: String,
			defaukt: '',
		},
		inactiveLabel: {
			type: String,
			defaukt: '',
		},
	},
  data() {
    return {};
  },
  computed: {
		activeOptions() {
			return {
				content: `${Math.round(this.percent) + '% '+ this.activeLabel}`,
				classes: 'progress-bar-tooltip',
			}
		},
		inactiveOptions() {
			return {
				content: `${Math.round(100 - this.percent) + '% '+ this.inactiveLabel}`,
				classes: 'progress-bar-tooltip',
			}
		}
	},
  created() {
	//   window.addEventListener('resize', this.getCardHeight);
  },
  mounted() {
	// this.getCardHeight();
  },
  destroyed() {
    // window.removeEventListener('resize', this.getCardHeight);
  },
  methods: {
	  	// getCardHeight() {
		// 	if(this.$refs.dashboardCard) {
		// 		this.$emit('getClientHeight',this.$refs.dashboardCard.clientHeight);
		// 	}
		// },
		sendAction(action) {
			if(this.hasAction) {
				this.$emit(action)
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.sm-data-box {
	.container-fluid {
		display: flex;
		justify-content: center;
		flex-direction: column;
	}
}

.with-action {
	cursor: pointer;
}

.progress {
	position: relative;
}

.progress .progress-popup {
	width: 120px;
	background-color: black;
	 text-align: center;
  padding: 5px 0;
  border-radius: 6px;
	visibility: hidden;
	position: absolute;
  z-index: 1;
}

.progress:hover .progress-popup {
	visibility: visible;
}

.custom-class {
	background: red;
}

.progress-bar-grey {
	background: rgba(120, 130, 140, 0.13)
}
</style>



// WEBPACK FOOTER //
// src/components/modules/dashboard/DashboardCard.vue